import React, { Suspense } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';
import { ToastContainer, Zoom } from 'react-toastify';
import RoutesIndex from './routes/Index';

import Page404 from './components/common/Page404';

function App() {
    return (
        <>
            <ToastContainer closeButton transition={Zoom} icon theme="dark" hideProgressBar />
            <Suspense>
                <Router>
                    <ErrorBoundary FallbackComponent={Page404}>
                        <RoutesIndex />
                    </ErrorBoundary>
                </Router>
            </Suspense>
        </>
    );
}

export default App;
